export enum RecoveryActionEnum {
  CANCEL = "CANCEL",
  RETRY = "RETRY",
  SKIP = "SKIP"
}
